import React from 'react';
import { CreditCardIcon, LockIcon } from 'lucide-react';
import { Section, CTAButton } from './shared';
export function FinalCTA() {
  return <div className="w-full bg-navy py-16 sm:py-20" data-id="element-85" data-mp="3udyl61gm95pd">
      <Section data-id="element-86" data-mp="c7ae4620a8h2">
        <div className="text-center" data-id="element-87" data-mp="c7twfnvkiyvm">
          <div className="flex justify-center" data-id="element-88" data-mp="c4o6k6f47syu">
            <CTAButton size="lg" data-id="element-89" data-mp="84xkuh4g4316">QUIERO MI MEGAPACK AHORA</CTAButton>
          </div>
          <p className="mt-6 font-display text-lg font-bold text-gold-soft" data-id="element-90" data-mp="m4ouy6rucz9w">
            GARANTÍA 45 DÍAS — Sin preguntas · Devolución 100%
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-blue-100/85" data-id="element-91" data-mp="h5lochw7qkzt">
            <span className="inline-flex items-center gap-2 rounded-lg bg-white/10 px-4 py-2 font-semibold text-white" data-id="element-92" data-mp="vwktfixuaren">
              Mercado Pago
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-93" data-mp="14w7svz70dn52">
              <CreditCardIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-94" data-mp="zwv9jofciy78" />
              Tarjeta de crédito / débito
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-95" data-mp="2c67tutwgjub5">
              <LockIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-96" data-mp="2h2y6f79207rt" />
              Pago 100% seguro
            </span>
          </div>
        </div>
      </Section>
    </div>;
}